import React, { useEffect, useState } from 'react';
import { dispatchService } from '../../../services/central-api/dispatch';
import FilterCheckboxList from '../FilterCheckboxList';

type Props = {
    actingBodyId: number;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
};

function OccurrenceTypesList({ value, setValue, actingBodyId }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    async function getOccurrenceTypes() {
        try {
            const response = await dispatchService.getDropDownOccurrenceTypes(actingBodyId);
            setItems(response.map(occurrenceType => ({
                label: occurrenceType.name, value: occurrenceType.id!
            })));
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getOccurrenceTypes();
        } else {
            setIsLoading(false);
            setItems([]);
        }
    }, [actingBodyId]);

    return <FilterCheckboxList items={items} value={value} setValue={setValue} isLoading={isLoading} />;
}

export default OccurrenceTypesList;
